<div *ngIf="showSpinner" class="spinner-overlay">
    <mat-spinner color="warn"></mat-spinner>
</div>